import { NgModule } from '@angular/core';

import { QuillEditorComponent } from './quillEditor.component';

@NgModule({
  declarations: [
    QuillEditorComponent
  ],
  exports: [
    QuillEditorComponent
  ]
})
export class QuillEditorModule {}



// WEBPACK FOOTER //
// C:/Users/EZepeda/Desktop/Explora/adminexplora/~/ng2-quill-editor/quillEditor.module.ts